import { useEffect } from 'react';

export default function useDisableScroll({
  isMobile = false,
  scrollRef,
  disableScroll = true,
}) {
  useEffect(() => {
    if (!isMobile && scrollRef && disableScroll) {
      const scrollLock = (event: WheelEvent) => {
        event.preventDefault();
        event.stopPropagation();
      };
      scrollRef.addEventListener('wheel', scrollLock);
      return () => {
        scrollRef.addEventListener('wheel', scrollLock);
      };
    }
  }, [scrollRef]);

  return null;
}
